import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { Message } from "primeng/message";
import { NewUiDateTimeComponent } from "../../shared/date-time/new-ui-date-time.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";

@Component({
  selector: "new-ui-formly-date-with-time",
  templateUrl: "./new-ui-formly-date-with-time.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NewUiDateTimeComponent,
    ReactiveFormsModule,
    FormlyModule,
    NewUiFormElementMapModule,
    TestIdDirective,
    Message,
  ],
})
export class NewUiFormlyDateWithTimeComponent extends FieldType {}
